'use strict';

export const ar = {
    name: 'ar',
    closeText: 'إغلاق',
    prevText: '&#x3C;السابق',
    nextText: 'التالي&#x3E;',
    currentText: 'اليوم',
    monthNames: ['كانون الثاني', 'شباط', 'آذار', 'نيسان', 'مايو', 'حزيران', 'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول'],
    monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesShort: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
    weekHeader: 'أسبوع',
    dateFormat: 'dd/mm/yy',
    firstDay: 6,
    isRTL: !0,
    showMonthAfterYear: !1,
    yearSuffix: ''
};
